import BlSeparatorAv from './BlSeparatorAv.vue'

BlSeparatorAv.install = function(Vue) {
  Vue.component(BlSeparatorAv.name, BlSeparatorAv)
}

export default BlSeparatorAv
